import React from 'react';
import { Text, Spinner, Center, HStack, VStack, Icon, Link } from '@chakra-ui/react';
import { FiClock } from 'react-icons/fi';
import { useTranslation } from '../../../../hooks/useTranslation';
import { useGetRegCustomerQuery } from '../../../../api';
import { SUPPORT_EMAIL, WEBSITE_URL } from '../../../../api/constants';
import Button from '../../../../components/base/Button';
import { render } from '../../../../utils/templateUtils';

type RegistrationStepProps = {
    onBack: () => void;
    onNext: () => void;
};

export const StepComplete: React.FC<RegistrationStepProps> = () => {
    const { t } = useTranslation();
    const { data: regCustomer, isLoading } = useGetRegCustomerQuery();

    if (isLoading) {
        return (
            <Center py={10} flexDirection="column" gap={4}>
                <Spinner size="lg" color="yellow.600" />
                <Text fontSize="md" color="gray.700" textAlign="center">
                    {t.registration.form.loadingRegCustomerData}
                </Text>
            </Center>
        );
    }

    return (
        <VStack align="stretch" w="full" h="full" minH={0} p={1}>
            <VStack
                align="center"
                justify="center"
                gap={4}
                flex={1}
                minH={0}
                overflowY="auto"
                pb={2}
                css={{
                    scrollbarWidth: 'none',
                    msOverflowStyle: 'none',
                }}
            >
                <Center
                    w="56px"
                    h="56px"
                    borderRadius="full"
                    bg="yellow.100"
                    color="yellow.600"
                    borderWidth="1px"
                    borderColor="yellow.300"
                >
                    <Icon as={FiClock} boxSize={6} />
                </Center>
                <Text fontSize="xl" fontWeight="bold" color="gray.800" textAlign="center">
                    {t.registration.form.moderationInProgressTitle}
                </Text>
                <Text fontSize="md" color="gray.700" textAlign="center">
                    {render(t.registration.form.moderationInProgressDescription, {
                        email: regCustomer?.email ?? '',
                    })}
                </Text>
                <Text fontSize="md" color="gray.500" textAlign="center">
                    {t.registration.form.moderationInProgressContact}{' '}
                    <Link href={`mailto:${SUPPORT_EMAIL}`} color="gray.600" textDecoration="underline">
                        {SUPPORT_EMAIL}
                    </Link>
                </Text>
            </VStack>

            <HStack gap={3} justify="space-between" w="full" flexShrink={0} pt={2}>
                <Button
                    buttonType="success"
                    size="lg"
                    flex={1}
                    onClick={() => {
                        window.location.href = WEBSITE_URL;
                    }}
                >
                    {t.registration.form.returnToWebsiteButton}
                </Button>
            </HStack>
        </VStack>
    );
};
